"use client";

import { Roles } from "@/data/globals";
import { env } from "@/env";
import useAuthorise from "@/hooks/framework/useAuthorise";
import { Alert, Container } from "@mui/material";

type Props = {
  container?: boolean;
};

const preProd = env.NEXT_PUBLIC_ENV === "alpha" || env.NEXT_PUBLIC_ENV === "staging";

export default function PreProdWarningMessage({ container }: Props) {
  if (!preProd) return null;

  const auth = useAuthorise();
  const isAdmin = auth(Roles.Admin);

  if (isAdmin) return null;

  const alert = (
    <Alert severity="error" sx={{ my: 2 }}>
      !!! THE RULES ARE EXPERIMENTAL - NOTHING IS FINAL - DON'T GET TOO ATTACHED - USE AT YOUR OWN PERIL !!!
    </Alert>
  );
  return container ? <Container>{alert}</Container> : alert;
}
